import './App.css';
import Login from "./Login";
import {useState} from "react";
import Dashboard from "./Dashboard";
import Navbar from "./Navbar";
const isAuthTokenSet = () => {
    const token = localStorage.getItem("Authorization");
    return token !== null && token !== undefined;
};

const checkLoggedIn = (setIsLoggedIn) => {
    if (isAuthTokenSet()) {

        const url = process.env.REACT_APP_SERVER_URL + "/status";
        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json", // Specify the content type
                "Authorization": localStorage.getItem("Authorization")
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); // Parse the JSON response
            })
            .then((result) => {
                setIsLoggedIn(true);

            })
            .catch((error) => {

            });

    } else {

    }

}

function App() {
    const [isLoggedIn,setIsLoggedIn] =useState(false);
    checkLoggedIn(setIsLoggedIn);

  return (
    <>
        <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
        {!isLoggedIn ? <Login setLoggedIn={setIsLoggedIn}/> : <Dashboard/>}
    </>
  );
}

export default App;
